import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: { "Content-Type": "application/json" },
});

export const setAuthToken = (token) => {
  if (token) api.defaults.headers.common["Authorization"] = `Bearer ${token}`;
  else delete api.defaults.headers.common["Authorization"];
};

export const getProduct = () => api.get("/product").then((r) => r.data);
export const getProducts = () => api.get("/products").then((r) => r.data);
export const getProductBySlug = (slug) => api.get(`/products/${slug}`).then((r) => r.data);
export const getReviews = () => api.get("/reviews").then((r) => r.data);
export const postReview = (payload) => api.post("/reviews", payload).then((r) => r.data);
export const getFaqs = () => api.get("/faqs").then((r) => r.data);
export const postOrder = (payload) => api.post("/orders", payload).then((r) => r.data);
export const createCheckoutSession = (payload) =>
  api.post("/checkout/session", payload).then((r) => r.data);
export const getCheckoutStatus = (sessionId) =>
  api.get(`/checkout/status/${sessionId}`).then((r) => r.data);

// Admin
export const adminLogin = (email, password) =>
  api.post("/admin/login", { email, password }).then((r) => r.data);
export const adminListOrders = () => api.get("/orders").then((r) => r.data);
export const adminListReviews = () => api.get("/admin/reviews").then((r) => r.data);
export const adminUpdateOrder = (id, status) =>
  api.patch(`/orders/${id}`, { status }).then((r) => r.data);
export const adminApproveReview = (id, approved) =>
  api.patch(`/reviews/${id}`, { approved }).then((r) => r.data);
export const adminDeleteReview = (id) =>
  api.delete(`/reviews/${id}`).then((r) => r.data);
